// Module
var code = "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M18 12a2 2 0 114 0 2 2 0 01-4 0zm-8 0a2 2 0 114 0 2 2 0 01-4 0zm-8 0a2 2 0 114 0 2 2 0 01-4 0z\" fill=\"currentColor\" fill-rule=\"evenodd\"/></svg>";
// Exports
module.exports = code;